var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLpFooterTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2788_4161)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    stroke: "#0D1615"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9377 9.38758C21.4849 9.58265 21.0088 9.71848 20.5212 9.79173C20.7492 9.75262 21.0846 9.34195 21.2181 9.17572C21.4209 8.92499 21.5755 8.63876 21.674 8.33157C21.674 8.30875 21.6968 8.27616 21.674 8.25986C21.6625 8.25359 21.6496 8.2503 21.6365 8.2503C21.6234 8.2503 21.6106 8.25359 21.5991 8.25986C21.0696 8.54682 20.5062 8.76583 19.922 8.91172C19.9017 8.91795 19.88 8.9185 19.8593 8.91334C19.8387 8.90817 19.8198 8.89747 19.8048 8.88239C19.7593 8.82819 19.7104 8.77702 19.6583 8.7292C19.42 8.51554 19.1497 8.34066 18.8572 8.21097C18.4624 8.04885 18.0359 7.97864 17.61 8.00564C17.1967 8.03176 16.7933 8.1427 16.4247 8.33157C16.0617 8.53068 15.7427 8.80119 15.4868 9.12683C15.2177 9.462 15.0234 9.85097 14.917 10.2676C14.8292 10.6639 14.8193 11.0734 14.8876 11.4735C14.8876 11.542 14.8876 11.5517 14.829 11.542C12.5072 11.1997 10.6022 10.3751 9.04568 8.60535C8.9773 8.52712 8.94148 8.52712 8.88612 8.60535C8.20879 9.63528 8.53769 11.2649 9.38435 12.07C9.49832 12.1775 9.61555 12.2818 9.73929 12.3796C9.35111 12.352 8.9724 12.2467 8.62561 12.07C8.56048 12.0276 8.52466 12.0504 8.5214 12.1286C8.51217 12.2371 8.51217 12.3461 8.5214 12.4546C8.58935 12.9743 8.79399 13.4666 9.11439 13.8812C9.4348 14.2958 9.85947 14.6178 10.345 14.8143C10.4633 14.865 10.5867 14.9033 10.713 14.9284C10.3536 14.9992 9.98501 15.0102 9.62206 14.961C9.54391 14.9447 9.5146 14.987 9.54391 15.062C10.0226 16.3657 11.0614 16.7633 11.8234 16.985C11.9276 17.0013 12.0318 17.0013 12.149 17.0273C12.149 17.0273 12.149 17.0273 12.1295 17.0469C11.9048 17.4576 10.9963 17.7346 10.5794 17.878C9.81864 18.1515 9.00749 18.2561 8.20228 18.1844C8.07528 18.1648 8.04597 18.1681 8.01341 18.1844C7.98084 18.2007 8.01341 18.2365 8.04923 18.2691C8.21205 18.3767 8.37487 18.4712 8.5442 18.5625C9.0483 18.8377 9.58124 19.0563 10.1333 19.2143C12.9924 20.0031 16.2097 19.4229 18.3557 17.2881C20.0425 15.6128 20.6352 13.302 20.6352 10.9879C20.6352 10.8999 20.7426 10.8477 20.8045 10.8021C21.2313 10.4693 21.6075 10.0763 21.9215 9.63528C21.9758 9.56955 22.0037 9.48585 21.9996 9.40061C21.9996 9.35172 21.9996 9.3615 21.9377 9.38758Z",
    fill: "#0D1615"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2788_4161",
    x: 0,
    y: 0,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2788_4161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2788_4161",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpFooterTwitter);
export default __webpack_public_path__ + "static/media/lp-footer-twitter.2efbac89afea63eba74961ceed8732f2.svg";
export { ForwardRef as ReactComponent };